export default {
    REQUEST_INVENTORY_MODIFIERS: "REQUEST_INVENTORY_MODIFIERS",
    REQUEST_INVENTORY_MODIFIERS_SUCCESS: "REQUEST_INVENTORY_MODIFIERS_SUCCESS",
    REQUEST_INVENTORY_MODIFIERS_FAILURE: "REQUEST_INVENTORY_MODIFIERS_FAILURE",

    SAVE_INVENTORY_MODIFIERS: "SAVE_INVENTORY_MODIFIERS",
    SAVE_INVENTORY_MODIFIERS_SUCCESS: "SAVE_INVENTORY_MODIFIERS_SUCCESS",
    SAVE_INVENTORY_MODIFIERS_FAILURE: "SAVE_INVENTORY_MODIFIERS_FAILURE"
};
